<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <div class="py-4">
          <div class="mb-6">
            <home-latest-notice :notices="latestNotices" />
          </div>
          <!-- <div class="aspect-w-16 aspect-h-9 mb-3">
            <iframe src="https://player.vimeo.com/video/917089699?h=d4e61b9b54" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" />
          </div> -->
          <div class="mb-6">
            <banner />
          </div>
          <div class="mb-6">
            <home-latest-browsing :browsings="latestBrowsings" />
          </div>
          <div class="mb-6">
            <div class="text-subtitle-underline">{{ t('course.title') }}</div>
            <course-list-contents />
          </div>
        </div>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed } from 'vue'
import { useStore } from '@/store/index'
import { useI18n } from 'vue-i18n'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import HomeLatestNotice from '@/components/HomeLatestNotice.vue'
import HomeLatestBrowsing from '@/components/HomeLatestBrowsing.vue'
import CourseListContents from '@/components/CourseListContents.vue'
import Banner from '@/components/Banner.vue'

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth,
    HomeLatestNotice,
    HomeLatestBrowsing,
    CourseListContents,
    Banner
  },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const latestNotices = computed(() => store.getters['notice/getLatestNotices']())
    const latestBrowsings = computed(() => store.getters['video/getLatestBrowsings']())

    onMounted(() => {
      Promise.allSettled([
        store.dispatch('video/fetchVideoBrowsings'),
        store.dispatch('notice/fetchNotices')
      ])
    })

    return {
      t,
      latestNotices,
      latestBrowsings
    }
  }
})
</script>
